import { memo, useContext } from "react";
import { createPortal } from "react-dom";
import { IoMdClose } from "react-icons/io";
import PersonalData from "./../personalData/PersonalData";
import Agreement from "../agreement/Agreement";
import style from "./modalWindow.module.css";
import { MainLayoutContext } from "../../layouts/MainLayout";

export const modalWindow = document.getElementById("modalWindow");

const ModalWindow = () => {
  const { isOpen, setIsOpen } = useContext(MainLayoutContext);


  return createPortal(
    <section
      className={`${
        isOpen.agreement || isOpen.policy ? style.active : style.close
      }  ${style.frame} ${isOpen.agreement && style.active_agreement} `}
      onClick={() =>
        setIsOpen((prev) => {
          return { ...prev, policy: false };
        })
      }
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={` ${style.close_container}
          ${isOpen.policy && style.container_policy} ${
            isOpen.agreement && !isOpen.policy && style.container_agreement
          }  `}
      >
        {isOpen.agreement && !isOpen.policy && <Agreement />}
        {isOpen.policy && !isOpen.agreement && (
          <>
            <button
              onClick={() =>
                setIsOpen((prev) => {
                  return { ...prev, policy: false };
                })
              }
              className={style.btn_close}
            >
              <IoMdClose />
            </button>
            <PersonalData />
          </>
        )}
        {isOpen.policy && isOpen.agreement && (
          <>
            <button
              onClick={() =>
                setIsOpen((prev) => {
                  return { ...prev, policy: false };
                })
              }
              className={style.btn_close}
            >
              <IoMdClose />
            </button>
            <PersonalData />
          </>
        )}
      </div>
    </section>,
    modalWindow,
  );
};

export default memo(ModalWindow);
